import { cn } from '@/lib/utils';
import type { HackerRole, ProfileFormData } from './types';

const ROLE_OPTIONS: { value: HackerRole; label: string; emoji: string }[] = [
  { value: 'desarrollo', label: 'Desarrollo', emoji: '💻' },
  { value: 'producto', label: 'Producto', emoji: '📱' },
  { value: 'diseno', label: 'Diseño', emoji: '🎨' },
  { value: 'ventas', label: 'Ventas', emoji: '💼' },
  { value: 'qa', label: 'QA', emoji: '🔍' },
];

interface Props {
  ownerName: string;
  data: ProfileFormData;
  onChange: (patch: Partial<ProfileFormData>) => void;
}

export function RoleStep({ ownerName, data, onChange }: Props) {
  const toggle = (role: HackerRole) => {
    const next = data.roles.includes(role)
      ? data.roles.filter((r) => r !== role)
      : [...data.roles, role];
    onChange({ roles: next });
  };

  return (
    <div className="space-y-8">
      <h2 className="font-bold text-3xl">{ownerName}.role</h2>

      <div className="space-y-6 text-secondary-foreground">
        <p className="text-lg">
          En cuál de los siguientes tienes{' '}
          <span className="text-foreground">*experiencia verificable*</span>?
        </p>
        <p className="text-sm">puedes elegir más de uno</p>
      </div>

      <div className="space-y-4">
        <div className="grid gap-3">
          {ROLE_OPTIONS.map((option) => {
            const isSelected = data.roles.includes(option.value);
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => toggle(option.value)}
                className={cn(
                  'flex items-center gap-3 rounded border px-6 py-4 text-left transition-all',
                  isSelected
                    ? 'border-primary bg-primary/10 text-primary'
                    : 'border-border bg-card text-foreground hover:border-primary/50',
                )}
              >
                <span className="text-2xl">{option.emoji}</span>
                <span className="font-medium text-lg">{option.label}</span>
                {isSelected && <span className="ml-auto text-primary">✓</span>}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
